
import { reactive, ref, watch } from 'vue';

import { Material, machines, Machine} from '@/logic/calculator';

import { unitType } from 'makerjs';

import { mdiDiameter, mdiDiameterOutline, mdiMagnify } from '@mdi/js';
import { registerIcons } from '@/Icons';

registerIcons({
	mdiDiameter,
	mdiDiameterOutline,
	mdiMagnify
});

const testProcessingArea = reactive({
	longSide: 3000,
	shortSide: 2000,
});

const testMaterial = reactive({
	thickness: 20,
	type: 'wood',
});

export default {
	name: 'BasicSettings',

	emits: ['update:material', 'update:machine', 'update:unit'],

	props: {
		machine: {
			type: Object as () => Machine,
			required: true,
		},
		material: {
			type: Object as () => Material,
			required: true,
        },
        unit: {
            type: String,
            required: true,
        },
	},

	setup(props, context) {

		const machineRef = ref<Machine>(props.machine);

		const unitRef = ref<string>(props.unit);

		const materialRef = reactive<Material>(props.material);

		watch( unitRef, () => {
			context.emit('update:unit', unitRef.value);
		});

		watch( machineRef, () => {
			context.emit('update:machine', machineRef.value);
		});

		watch( materialRef, () => {
			context.emit('update:material', materialRef);
		});

		// Fills in Testdata to show User possible Inputs
		function fillTestData(): void {
			machineRef.value.processingArea = testProcessingArea;
            machineRef.value.tolerance = 3;
            materialRef.type = testMaterial.type;
            materialRef.thickness = testMaterial.thickness;
		}

		return {
			materialRef,
			unitType,
			machineRef,
			machines,
			unitRef,
            
            //Functions
            fillTestData,
		};
	},
};
